import DownloadIcon from "@assets/images/down-arrow.svg";
import { IconButton } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@saleor/components/Container";
import PageHeader from "@saleor/components/PageHeader";
import Skeleton from "@saleor/components/Skeleton";
import { batchDetailsQuery_batchDetails_data } from "@saleor/reports/batch/types/batchDetailsQuery";
import * as React from "react";

import BatchHistoryDetailsList from "../BatchHistoryDetailsList";
import BackButton from "../BatchHistoryDetailsList/components/BackButton";

interface BatchHistoryDetailsPageProps {
  batchDetails: batchDetailsQuery_batchDetails_data[];
  loading: boolean;
  onDownload: () => void;
}

const useStyles = makeStyles(
  theme => ({
    card: {
      marginTop: "20px",
      padding: "20px"
    },
    download: {
      backgroundColor: "#FFD15C",
      borderRadius: "6px",
      height: "35px",
      width: "35px"
    },
    id: {
      display: "flex",
      justifyContent: "space-between",
      marginLeft: "23px",
      marginTop: "4px",
      width: "400px"
    },
    imgDownload: {
      width: "20px"
    },
    pageActions: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: theme.spacing(3),
      paddingRight: 0
    },
    specialistActionBtn: {
      "& :nth-child(2)": {
        marginRight: "10px"
      },
      display: "flex",
      flexDirection: "row-reverse",
      justifyContent: "space-between"
    },
    title: {
      alignItems: "end"
    },
    titleSkeleton: {
      display: "flex",
      height: "1em",
      justifyContent: "space-between",
      marginLeft: "23px",
      width: "400px"
    }
  }),
  { name: "BatchHistoryDetailsPage" }
);

const BatchHistoryDetailsPage: React.FC<BatchHistoryDetailsPageProps> = props => {
  const { batchDetails: data, loading, onDownload } = props;
  const classes = useStyles(props);

  const batchDetails = data && data[0];
  const batchIdFormat = `${batchDetails?.batch_id}`;

  return (
    <Container>
      <Container className={classes.pageActions}>
        <BackButton />
        <IconButton
          color="primary"
          className={classes.download}
          onClick={onDownload}
        >
          <img src={DownloadIcon} className={classes.imgDownload} />
        </IconButton>
      </Container>
      <Card className={classes.card}>
        <PageHeader
          className={classes.title}
          title={
            loading ? (
              <Skeleton className={classes.titleSkeleton} />
            ) : (
              <label className={classes.id}>{batchIdFormat}</label>
            )
          }
        ></PageHeader>
        <BatchHistoryDetailsList batchDetails={data} />
      </Card>
    </Container>
  );
};

export default BatchHistoryDetailsPage;
